// extracted by mini-css-extract-plugin
export default {"container":"jl-z","bubbleNav":"kl-z","graphic":"ll-z","contact":"ml-z"};